import { IEventStatisticScoresByPeriodProps } from './EventStatisticScoresByPeriod.types'

export const WRAP_SYMBOLS: NonNullable<
  IEventStatisticScoresByPeriodProps['wrapSymbol']
> = {
  start: '(',
  end: ')'
}
